import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b312872&scoped=true"
import script from "./vuetifyContentLoading.js?vue&type=script&lang=js&external"
export * from "./vuetifyContentLoading.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=7b312872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b312872",
  null
  
)

export default component.exports